import React from 'react';

const FeeForm = ({ form, formError, onChange, onSubmit, onCancel, isEdit, students }) => (
  <form onSubmit={onSubmit} className="modal-form">
    <select className="feeform-student-select" value={form.student} onChange={e=>onChange('student', e.target.value)} required>
      <option value="" disabled>Select Student</option>
      {students && students.map(student => (
        <option key={student._id} value={student._id}>{student.name} - {student.class} {student.section}</option>
      ))}
    </select>
    <select value={form.class} onChange={e=>onChange('class', e.target.value)} required>
      <option value="" disabled>Class</option>
      <option value="Class 1">Class 1</option>
      <option value="Class 2">Class 2</option>
      <option value="Class 3">Class 3</option>
      <option value="Class 4">Class 4</option>
      <option value="Class 5">Class 5</option>
      <option value="Class 6">Class 6</option>
      <option value="Class 7">Class 7</option>
      <option value="Class 8">Class 8</option>
      <option value="Class 9">Class 9</option>
      <option value="Class 10">Class 10</option>
      <option value="Class 11">Class 11</option>
      <option value="Class 12">Class 12</option>
    </select>
    <select value={form.section} onChange={e=>onChange('section', e.target.value)}>
      <option value="" disabled>Section</option>
      <option value="A">A</option>
      <option value="B">B</option>
      <option value="C">C</option>
      <option value="D">D</option>
      <option value="E">E</option>
    </select>
    <input type="number" placeholder="Amount" value={form.amount} onChange={e=>onChange('amount', e.target.value)} required />
    <input type="date" placeholder="Due Date" value={form.dueDate} onChange={e=>onChange('dueDate', e.target.value)} required />
    <input type="text" placeholder="Description" value={form.description} onChange={e=>onChange('description', e.target.value)} />
    <div className="modal-actions">
      <button type="submit">{isEdit ? 'Save' : 'Add'}</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </div>
    {formError && <div className="error">{formError}</div>}
  </form>
);

export default FeeForm; 